/**
 * Blog / CPT lista section.
 *  - Swiper init (carousel mode)
 *  - Load more gomb kezelés
 *
 * DOMContentLoaded-be csomagolva: a deferelt scriptek dokumentum-sorrendben
 * futnak, és a main.min.js MEGELŐZHETI a swiper-bundle-t -- azonnali futásnál
 * a Swiper még undefined lenne, és a carousel csendben nem indulna el.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // --- Swiper init (carousel) ---
    var swipers = document.querySelectorAll('.blog-cpt-lista__swiper');
    if (swipers.length && typeof Swiper !== 'undefined') {
      swipers.forEach(function (el) {
        var cols = parseInt(el.getAttribute('data-cols'), 10) || 3;
        new Swiper(el, {
          loop: false,
          speed: 500,
          spaceBetween: 24,
          slidesPerView: 1,
          breakpoints: {
            576: { slidesPerView: 2 },
            992: { slidesPerView: cols }
          }
        });
      });
    }

    // --- Load more ---
    var sections = document.querySelectorAll('.blog-cpt-lista[data-load-more="1"]');
    sections.forEach(function (sec) {
      var btn   = sec.querySelector('.blog-cpt-lista__more-btn');
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 6;
      if (!btn) return;

      btn.addEventListener('click', function () {
        var hidden = Array.prototype.slice.call(sec.querySelectorAll('.blog-cpt-lista__card[data-hidden="1"]'));
        var toShow = hidden.slice(0, limit);
        toShow.forEach(function (card) {
          card.removeAttribute('data-hidden');
          card.style.display = '';
        });
        if (hidden.length - toShow.length <= 0) {
          btn.parentElement.style.display = 'none';
        }
      });
    });
  });
})();
